// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"18952":"84d7068e15ea8e112093","25825":"72340b8e8f7051425030","80020":"12f36af1cb29c16f2d8e"}[chunkId] + ".css";
};